// import 'babel/polyfill'

// NOTE see https://github.com/shakacode/bootstrap-sass-loader if we you need to
// customize bootstrap variables
//import 'bootstrap-sass-loader'

//importing this way because it isnt being read from node-modules
import './vendor/jquery-scrolltofixed.js'

import './modules/_post-object.js'

import './modules/_query.js'

import './modules/_slideshow.js'

import './modules/_icon-slider.js'

import './modules/_tabs.js'

import './modules/_mega-menu.js'

import './modules/_FooterMenu.js'

import './modules/_MobileMenu.js'

import './modules/_load-posts.js'

import './modules/headerBanner.js'

import './modules/map.js'

import './modules/events.js'

import './custom/ada.js'

import '../sass/app.scss'



// WEBPACK FOOTER //
// ./wp-content/themes/figpress-child/src/js/main.js